import { Box } from '@factorialco/deprecated-design-system'
import { PieChart } from '@factorialco/f0-react'

import { SupportedColors } from './types'

interface ChartData {
  color?: SupportedColors
  label: string
  status?: string
  value: number
}

interface Props {
  totalChartData?: {
    label: string
    value: number
  }
  groupedChartData: ChartData[]
  tickFormatter: (value: string) => string
}

interface Item {
  label: string
  value: number
}

interface ItemConfig {
  [key: string]: {
    label: string
    color: SupportedColors
  }
}

export const PieChartWrapper = ({ totalChartData, groupedChartData, tickFormatter }: Props) => {
  const pieChartData: Item[] = groupedChartData.map((x) => ({
    label: x.status || '',
    value: x.value,
  }))

  const pieChartDataConfig = groupedChartData.reduce((acc: ItemConfig, x) => {
    acc[x.status || ''] = {
      label: x.label,
      color: x.color || 'feedback-neutral',
    }
    return acc
  }, {})

  return (
    <Box width="full" minWidth="s300" height="full">
      <PieChart
        data={pieChartData}
        dataConfig={pieChartDataConfig}
        tickFormatter={tickFormatter}
        overview={
          totalChartData && {
            label: totalChartData.label,
            number: totalChartData.value,
          }
        }
      />
    </Box>
  )
}
